import { useState } from 'react';

export const useSimulation = () => {
    const [isSimulateActive, setIsSimulateActive] = useState(false);
    const [stitchColorMap, setStitchColorMap] = useState([]);

    return {
        isSimulateActive,
        setIsSimulateActive,
        stitchColorMap,
        setStitchColorMap
    };
};
